/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'manufacturer': {
    width: 41,
    height: 40,
    viewBox: '0 0 41 40',
    data: '<path pid="0" d="M39.5 37.324h-38v-13.38l5.887-9.366 4.282 7.225 4.55-6.958 4.281 6.69 4.282-6.957 4.281 6.69V2H39.5v35.324z" _fill="#1F222C"/>'
  }
})
